export const AD_PRICE_TYPE_KEYS = [
  "amount",
  "or-near-offer",
  "negotiable",
  "poa",
  "free",
] as const;

export type AdPriceType = (typeof AD_PRICE_TYPE_KEYS)[number];

export interface AdPriceTypeOption {
  label: string;
  value: AdPriceType;
  hidePrice?: boolean;
}

export const AD_PRICE_TYPE_OPTIONS: AdPriceTypeOption[] = [
  { label: "Amount", value: "amount" },
  { label: "Or Near Offer", value: "or-near-offer" },
  { label: "Negotiable", value: "negotiable" },
  { label: "POA", value: "poa", hidePrice: true },
  { label: "Free", value: "free", hidePrice: true },
];
